import { fetchClient } from '../../Utils/helpers';
import { GET_NOTIFICATIONS } from '../actionTypes';

export function getNotifications(uid, { type = '', page = 1 }) {
  return {
    type: GET_NOTIFICATIONS,
    payload: fetchClient({
      method: 'GET',
      url: `/user-notification/${uid}?type=${type}&page=${page}`,
    }),
  };
}
